import { render, staticRenderFns } from "./CloneRent.vue?vue&type=template&id=2ef81b9c&scoped=true&"
import script from "./CloneRent.vue?vue&type=script&lang=js&"
export * from "./CloneRent.vue?vue&type=script&lang=js&"
import style0 from "./CloneRent.vue?vue&type=style&index=0&id=2ef81b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef81b9c",
  null
  
)

export default component.exports